import React from 'react';
import AvatarComp from '../../helper/avatar';
import {WbMarkdownHtml} from '../../../utils/common';

import './style.scss';
import { useTranslation } from 'react-i18next';

export const GoalBoxComp = (props) => {
    const items = props.items || [];
    const {t} = useTranslation();
    let imageProps = {src: props.picture};
    let isTeam = false;
    let headerStyle = {};
    let viewTeamLabel = t('View team');
    let headerClass = '';
    let wrapperStyle = {};
    if (typeof props.type !== 'undefined' && props.type == 'team') {
        imageProps.imageClass = '';
        isTeam = true;
        viewTeamLabel = props.viewTeamLabel || viewTeamLabel;
    }
    if (!isTeam) {
        headerStyle.width = '100%';
        headerStyle.cursor = 'pointer';
    }
    if (typeof props.isPage !== 'undefined' && props.isPage) {
        wrapperStyle.marginLeft = '20px';
        wrapperStyle.marginTop = '120px';
        headerClass = 'goalbox-header-left-group';
    }
    const viewTeam = (teamId) => {
        let url = wbConfig.baseUrl + "/goal/teamGoal?teamId=" + teamId + "&js=1";
        window.open(url, '_blank');
    }
    return (
        <div className='goalbox-comp-wrapper' style={wrapperStyle}>
            <div className='goalbox-header'>
                <div className={'goalbox-header-left ' + headerClass } style={headerStyle} >
                    <AvatarComp src={props.picture} useSpriteSheet={props.useSpriteSheet}/>
                    <div className='head-wrapper'>
                        <div className='head-title'>
                            {props.title}
                        </div>
                        <div className='head-subtitle'>
                            {props.subTitle}
                        </div>
                    </div>
                </div>
                {
                    isTeam ?
                    <div className='goalbox-header-right'>
                        <div className="view-working-group" onClick={() => viewTeam(props.id)}>{viewTeamLabel}</div>
                    </div>
                    :
                    <div className='goalbox-header-right'>
                        <div className="view-working-group" onClick={ e => {props.clickPeopleAlign(e, props.id)}}>
                            <img width="30" height="30"  className="fitProfileImage roundFramePhoto" src="./../images/icons/main_menu/switchflow.png"/>
                        </div>
                    </div>      
                }
               
            </div>
            {
                items.length ?
                <div className='goalbox-content'>
                    {
                        items.map((item, i) => <RenderGoalRow key={'grow-' + item.id + '-' + i} {...item} />)
                    }
                </div>
                :
                ""
            }
            
        </div>
    )
}

export const RenderGoalRow = React.memo((props) => {
    const viewGoalPage = (props) => {
        var params = {};
        params.id = props.id;
        // Prevent history pushState which causes the tree to re-render and lose state.
        params.onModalCloseCallback = () => {};
        viewGoalDetailsPage(undefined, params);
    }
    return (
        <div className='render-goal-row'>
            <div className='render-goal-name'>
                <span style={{cursor: 'pointer'}}
                      onClick={ () => viewGoalPage(props)}>
                    {props.goal}
                </span>
            </div>
            <div className='render-goal-progress'>
               <span style={{color: props.progressColor}}>
                    {props.goalPercentage}%
                </span>
            </div>
        </div>
    );
});